namespace SPA
{
	export namespace gui
	{
		export namespace view
		{
			export class TreeViewNode<T>
			{
				protected m_Nodes: Array<TreeViewNode<T>>;
				protected m_Leafs: Array<TreeViewNode<T>>;

				public constructor()
				{
					this.m_Nodes = new Array();
					this.m_Leafs = new Array();
				}
			}
		}
	}
}
